(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('NewsCustom', NewsCustom);

    NewsCustom.$inject = ['$resource', 'ENV'];

    function NewsCustom($resource, ENV) {


        var getActiveNewsByCurrentCompany = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-active-news-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getActiveNewsByCurrentCompanyWithOutSystemNotification = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-active-news-by-current-company-with-out-system-notification';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getActiveNewsByCurrentCompany: getActiveNewsByCurrentCompany,
            getActiveNewsByCurrentCompanyWithOutSystemNotification: getActiveNewsByCurrentCompanyWithOutSystemNotification

        };
    }
})();
